module.exports = __webpack_public_path__ + "img/366x406.f851b2fe.png";